// extracted by mini-css-extract-plugin
module.exports = {"coverPhoto":"CoverPhotoPanel_coverPhoto__1JCiF","placeholder":"CoverPhotoPanel_placeholder__NwE8f"};